import { Checkbox } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { StyledCard } from '../../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { CardContentWrapper } from '../../../../../solceller/form/components/styledComponents';
import { VarmesentralRadio } from '../../common/varmesentralRadio';
import { OppvarmingFormData } from '../../../../types';
import { ServiceSisteToArRadio } from '../../common/serviceSisteToArRadio';
import { VarmesystemBrukCheckboxes } from '../../common/varmesystemBruk';
import { useOljeValidation } from '../useOljeValidation';
import { InstallertIOppvarmetRomRadio } from '../../common/installertIOppvarmetRomRadio';
import { InstallasjonsArRadio } from '../../../../../../components/installasjonsArRadio';

import { Fordelingssystem } from './fordelingssystem';

export const Oljekjel = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming' });
  const { validateOljeSelection } = useOljeValidation();

  const oljeKjelSelected = watch('olje.value.kjel.selected');
  const oppvarmingBrukSelection = watch(`olje.value.kjel.value.bruk`);
  const showFordelingssystem = oppvarmingBrukSelection?.romoppvarming;

  return (
    <StyledCard isActive={oljeKjelSelected}>
      <CardContentWrapper>
        <Checkbox
          aria-invalid={!!formState.errors.olje?.value?.kjel?.selected}
          label={t('olje.kjel.label')}
          {...register('olje.value.kjel.selected', {
            deps: ['olje.value.kamin.selected'],
            validate: validateOljeSelection,
            shouldUnregister: true
          })}
        />
        {oljeKjelSelected && (
          <Fragment>
            <InstallasjonsArRadio
              name="olje.value.kjel.value.varmesentral"
              translationKeyPrefix="form.oppvarming.olje.kjel.varmesentral.installasjonsAr" />
            <VarmesentralRadio name="olje.value.kjel.value.varmesentral.varmesentralType" />
            <InstallertIOppvarmetRomRadio name="olje.value.kjel.value.varmesentral.installertIOppvarmetRom" />

            <InstallasjonsArRadio
              name="olje.value.kjel.value"
              translationKeyPrefix="form.oppvarming.olje.kjel.installasjonsAr" />
            <ServiceSisteToArRadio name="olje.value.kjel.value.serviceGjennomfortSiste2Ar" />

            <VarmesystemBrukCheckboxes name="olje.value.kjel.value.bruk" />

            {showFordelingssystem && <Fordelingssystem />}
          </Fragment>
        )}
      </CardContentWrapper>
    </StyledCard>
  );
};
